var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 7.99992C10.0002 9.10449 9.10473 9.99992 8.00016 9.99992C6.89559 9.99992 6.00016 9.10449 6.00016 7.99992C6.00016 6.89535 6.89559 5.99992 8.00016 5.99992C9.10473 5.99992 10.0002 6.89535 10.0002 7.99992Z",
    fill: "#0067DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5964 7.70178C13.1576 4.82415 10.6022 3.33325 8.00016 3.33325C5.39808 3.33325 2.84269 4.82415 1.40388 7.70178C1.31004 7.88946 1.31004 8.11038 1.40388 8.29806C2.84269 11.1757 5.39808 12.6666 8.00016 12.6666C10.6022 12.6666 13.1576 11.1757 14.5964 8.29806C14.6903 8.11038 14.6903 7.88946 14.5964 7.70178ZM8.00016 11.3333C6.02097 11.3333 3.99887 10.2527 2.75327 7.99992C3.99887 5.74711 6.02097 4.66659 8.00016 4.66659C9.97935 4.66659 12.0015 5.74711 13.2471 7.99992C12.0015 10.2527 9.97935 11.3333 8.00016 11.3333Z",
    fill: "#0067DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.0f912afb.svg";
export { ForwardRef as ReactComponent };